import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { MdAdd, MdExpandMore } from 'react-icons/md';
import { ApprovalPickerTrigger } from '@components/Chat/Chat.styled';
import AppSkillsPicker from '../AppSkillsPicker';
import { useAppSkills } from '../useAppBuilder';

interface SkillPickerChipProps {
  readonly selected: readonly string[];
  readonly onChange: (selected: string[]) => void;
  readonly disabled?: boolean;
}

const SkillPickerChip: React.FC<SkillPickerChipProps> = ({ selected, onChange, disabled }) => {
  const intl = useIntl();
  const skills = useAppSkills();
  const [open, setOpen] = useState(false);

  if (skills.isError || skills.data?.length === 0) return null;

  const label =
    selected.length === 0
      ? intl.formatMessage({ id: 'apps.builder.create.skills.add', defaultMessage: 'Add skill' })
      : intl.formatMessage(
          { id: 'apps.builder.create.skills.count', defaultMessage: '{count, plural, one {# skill} other {# skills}}' },
          { count: selected.length },
        );

  return (
    <>
      <ApprovalPickerTrigger
        type="button"
        onClick={() => setOpen(true)}
        disabled={disabled || !skills.data}
        aria-haspopup="dialog"
        data-testid="create-app__skills"
      >
        <MdAdd aria-hidden="true" />
        {label}
        <MdExpandMore aria-hidden="true" />
      </ApprovalPickerTrigger>
      <AppSkillsPicker
        open={open}
        onClose={() => setOpen(false)}
        skills={skills.data ?? []}
        selected={selected}
        onConfirm={onChange}
      />
    </>
  );
};

export default SkillPickerChip;
